import EmptyCard from '@components/elements/card/emptyCard';
import EpgEvent from '../../../../../../shared/classes/epgEvent';
import List from '../../list';
import MainContext from '../../../../../../shared/components/utils/context/mainContext';
import RailProps from '../../../../../../shared/types/props/rail';
import RegularEvent from '../../../../../../shared/classes/regularEvent';
import SquareCard from '../../../../elements/card/squareCard';
import goToContent from '../../../../../../shared/actions/content/goToContent';
import useUpdateEvents from '../../../../../../shared/components/utils/hooks/useUpdateEvents';
import useUpdateChannels from '../../../../../../shared/components/utils/hooks/useUpdateChannels';
import { RailDisplayMode } from '../../../../../../shared/types/enums/rail';
import { store } from '../../../../../../shared/store/store';
import { useCallback, useContext, useEffect, useState } from 'react';
import EventCard from '@components/elements/card/eventCard';

function EpgRail({ list }: RailProps) {
  const [canResetStyle, setCanResetStyle] = useState(false);
  const { filter, setAsset } = useContext(MainContext);
  const {
    data,
    ogData,
    displayMode,
    focus: listFocus,
    index,
    setListIndex,
    onClick,
    resetStyle,
    updateData,
  } = list;

  const filteredData = ogData.filter((event) => {
    if (!filter) return true;
    return (
      event?.channel?.category === filter.id ||
      event?.channel?.category === filter.name
    );
  }) as (EpgEvent | RegularEvent | undefined)[];

  // Actions

  const changeDescription = useCallback(() => {
    const { events, focus: focusSlice } = store.getState();
    const isFocused =
      (focusSlice.focus as number[]).length &&
      (focusSlice.focus as number[]).includes(listFocus);
    if (
      isFocused &&
      data &&
      index !== undefined &&
      (data as (EpgEvent | undefined)[])[index]?.channel?.id
    ) {
      setTimeout(() => {
        setAsset(
          events.currentEvents[
            (data as (EpgEvent | undefined)[])[index || 0]?.channel?.id || ''
          ]
        );
      });
    }
  }, []);

  // Event data handling

  const updatedEvents = useUpdateEvents({
    data: filteredData,
    changeDescription,
    filter: filter?.id || '',
  });

  const finalEvents = useUpdateChannels({
    data: updatedEvents,
    index,
    setListIndex,
    updateData,
  });

  // Use effects

  useEffect(() => {
    if (canResetStyle) {
      setListIndex?.current(0, 0);
      resetStyle();
    } else {
      setCanResetStyle(true);
    }
  }, [filter]);

  return finalEvents?.length ? (
    <List {...list}>
      {(finalEvents as (EpgEvent | RegularEvent | undefined)[])?.map(
        (item: EpgEvent | RegularEvent | undefined, index: number) => {
          if (!item) return;
          switch (displayMode) {
            case RailDisplayMode.PHOTO:
              return (
                <EventCard
                  key={index}
                  item={item as EpgEvent}
                  index={index}
                  onClick={() => onClick(item, index, listFocus)}
                  releaseAction={() => goToContent(item)}
                />
              );

            case RailDisplayMode.SQUARE:
              return (
                <SquareCard
                  key={index}
                  item={item as EpgEvent}
                  index={index}
                  onClick={() => onClick(item, index, listFocus)}
                  releaseAction={() => goToContent(item)}
                />
              );
          }
        }
      )}
    </List>
  ) : (
    <EmptyCard displayMode={displayMode as RailDisplayMode} />
  );
}

export default EpgRail;
